// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchList_wrapper__LkJok","tickIcon":"SearchList_tickIcon__1U8rW"};